import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onMounted,
  ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Observer',
  props: {
    threshold: { default: 0 },
    clearOnEnter: { type: Boolean, default: true }
  },
  emits: ["observeenter", "observeleave", "resize"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const root = ref<HTMLElement>();
const rootSize = ref<{
  height?: number
  width?: number
}>({
  width: undefined,
  height: undefined,
});

const setRootSize = (): void => {
  rootSize.value.width = root.value?.offsetWidth;
  rootSize.value.height = root.value?.offsetHeight;

  emit('resize', rootSize.value);
};

const handleIntersect = (
  entries: IntersectionObserverEntry[],
  observer: IntersectionObserver,
): void => {
  let entered = false;

  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entered = true;
    }
  });

  if (entered) {
    emit('observeenter', root.value);
    if (props.clearOnEnter && root.value) {
      observer.unobserve(root.value);
    }
  } else {
    emit('observeleave', root.value);
  }
};

const createObserver = (): void => {
  const observer = new IntersectionObserver(handleIntersect, {
    root: null,
    threshold: props.threshold,
  });

  const resizeObserver = new ResizeObserver(setRootSize);

  if (root.value) {
    observer.observe(root.value);
    resizeObserver.observe(root.value);
  }
};

onMounted(() => {
  if (window.IntersectionObserver) {
    createObserver();
  } else {
    emit('observeenter', root.value);
  }

  setRootSize();
});

__expose({
  setRootSize,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})